import { Flip, toast } from "react-toastify"

export const CustomToast = (type: any, message: any) => {

    const Error = toast[type](message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Flip
    })
    return Error
} 